// TODO 移动端即使使用鼠标，也可能无法在全屏模式下让hover正常工作，因此目前
import { UAParser } from 'ua-parser-js'
import { ref } from 'vue'

export const useMediaJudgement = () => {
  const isMouse = ref(false)
  const { device } = UAParser(navigator.userAgent)

  const isMobile = ref(device.is('mobile'))

  // const handleMouseEnter = () => {
  //   console.log('mousemove')
  //   isMouse.value = true
  // }

  // const handleTouchStart = () => {
  //   isMouse.value = false
  // }

  // // onMounted(() => {
  // //   window.addEventListener('mousemove', handleMouseEnter)
  // //   window.addEventListener('touchstart', handleTouchStart)
  // // })

  // // onUnmounted(() => {
  // //   window.removeEventListener('mousemove', handleMouseEnter)
  // //   window.removeEventListener('touchstart', handleTouchStart)
  // // })

  return { isMouse, isMobile }
}

export type UseMediaJudgement = ReturnType<typeof useMediaJudgement>
